// Ezreal — Mystic Shot: fires a precise energy bolt that hits the front enemy.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const ezrealMysticShot: Ability = {
  id: "ezrealMysticShot",
  displayName: "Mystic Shot",
  description: "Fires an energy bolt at the nearest enemy for heavy physical damage.",
  iconId: "EzrealQ",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    if (!target) return [];
    const stats = effectiveStats(caster);
    return [{ target, amount: physicalDamage(stats.ad * 2.5 + 80), type: "physical", suppressPopup: true, ezrealPass: true }];
  },
};
